<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'leads.import.index'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                    <div class="card">
                        <div class="card-header card-header-icon card-header-rose">
                            <div class="card-icon" v-b-toggle.filter>
                                <i class="material-icons">search</i>
                            </div>
                            <h4 class="card-title">Filtros</h4>
                        </div>
                        <br />
                        <b-collapse id="filter">
                            <div class="card-body">
                                <div class="row">
                                    <FilterLeadType class="col-md-4" :type="form.lead_type"
                                                    @update-lead-type="updateLeadType" />
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="interval" class="bmd-label-floating">Intervalo Data</label>
                                            <date-picker
                                                range
                                                v-model="form.interval"
                                                lang="pt-br"
                                                format="DD/MM/YYYY"
                                                placeholder="Escolha uma data"
                                                :not-after="form.end_at"
                                                ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="salesmans" class="bmd-label-floating">Vendedor</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="salesmans"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.user_id"
                                                ></model-list-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group bmd-form-group is-filled">
                                            <label for="group_id" class="bmd-label-floating">Status</label>
                                            <model-list-select
                                                class="form-control"
                                                :list="leads_status"
                                                option-value="id"
                                                option-text="status"
                                                v-model="form.leads_status_id"
                                                ></model-list-select>
                                        </div>
                                    </div>

                                <div class="col-md-4">
                                    <div
                                            class="form-group bmd-form-group"
                                            v-bind:class="{'is-filled': form.name != ''}"
                                    >
                                        <label for="name"  class="bmd-label-floating">Nome</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                    </div>
                                </div>

                                </div>

                            </div>
                            <div class="card-footer">
                                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
                            </div>
                        </b-collapse>
                    </div>
                </b-form>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Leads</h4>
                    </div>
                    <div class="card-body">
                        <div class="row pb-3" style="border-bottom: 1px solid rgba(0,0,0,0.1)">
                            <div class="col-md-2">
                                <router-link id="proposal-cancel" data-original-title title="Dividir Leads" class="btn btn-block btn-fill btn-success" tag="button" :to="{'name': 'leads.supervise.share'}">
                                    Dividir Leads
                                </router-link>
                            </div>
                            <div class="col-md-2 text-right offset-md-4 pt-2">
                                Passar Lead para:
                            </div>
                            <div class="col-md-2 pl-0 pr-0">
                                <model-list-select
                                    class="form-control"
                                    :list="salesmans"
                                    option-value="id"
                                    option-text="name"
                                    v-model="passTo"
                                    ></model-list-select>
                            </div>
                            <div class="col-md-2">
                                <button type="button" @click="passLeads(items)" class="btn btn-block btn-fill btn-rose">Atualizar</button>
                            </div>
                        </div>
                        <div class="table-responsive pt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><input v-model="checked" style="position: static;left:auto;opacity: 1" type="checkbox" @change="checkAll(items)"/></th>
                                        <th class="text-center">#</th>
                                        <th>Data da Próxima Visita</th>
                                        <th>Nome</th>
                                        <th>Telefone</th>
                                        <th>E-mail</th>
                                        <th>Vendedor</th>
                                        <th>Status</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-show="items.length > 0" v-for="iterator in items" :key="iterator.id">
                                        <td><input :name="'checkbox-' + iterator.id" @change="check(iterator)" v-model="iterator.checked" :checked="iterator.checked" style="position: static;left:auto;opacity: 1" type="checkbox"></td>
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ moment(iterator.date).format('DD/MM/YYYY') }}</td>
                                        <td>{{ iterator.name }}</td>
                                        <td>{{ iterator.phone || '-' }}</td>
                                        <td>{{ iterator.email || '-' }}</td>
                                        <td>{{ iterator.user ? iterator.user.name : 'Não Atribuido' }}</td>
                                        <td style="width: 50px" :style="{'color': iterator.lead_status.color}">{{iterator.lead_status.status}}</td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="false"
                                                :toAudit="{name: 'teams.index'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'leads.agenda.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="lead/rem"
                                                :callbackRemove="getData">
                                            </index-buttons>
                                        </td>
                                    </tr>
                                    <tr v-show="items.length==0">
                                        <td colspan="7">Nenhum lead encontrado!</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer" v-show="items.length > 0">
                        <div class="row" style="width: 100%">
                            <div class="col-sm-4">
                                <model-list-select
                                  class="form-control"
                                  :list="limits"
                                  option-value="limit"
                                  option-text="text"
                                  v-model="limit"
                                  @input="onSubmit($event)"
                                ></model-list-select>
                            </div>
                            <div class="col-sm-4 text-center">
                                <b-pagination
                                    order="is-right"
                                    v-show="items.length > 0"
                                    v-model="currentPage"
                                    :simple="false"
                                    :per-page="limit"
                                    :total-rows="total"
                                    @change="pageChange"
                                    ></b-pagination>
                            </div>
                            <div class="col-sm-4 text-right text-secondary">
                                {{ to }} registros de {{ total }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import FilterLeadType from './FilterLeadType';
    import JwtService from "@/services/jwt.service";
    import UserService from "@/services/modules/users.service";
    import Vue from "vue";

    export default {
        components: {
            'FilterLeadType': FilterLeadType
        },
        computed: {
            items: {
                set(_itens) {
                    this.$store.commit('lead/setList', []);
                },
                get() {
                    return this.$store.state.lead.itens;
                }
            }

        },
        created: function () {
            this.checked = false;
            this.passTo = null;
            this.leads = [];
            this.salesmans = [];
            this.leads_status = [];
            this.updateLeadType("active");
            this.$root.$on("loadLeads", this.onSubmit);
            setTimeout(this.getDataSalesmans, 800);

            this.initQueryString();
        },
        data() {
            return {
                moment: Vue.moment,
                currentPage: 1,
                form: {
                    interval: [Vue.moment(), Vue.moment().add(30, "days")],
                    leads_status_id: "",
                    lead_type: "",
                    user_id: '',
                    name: ''
                },
                groups: [],
                hideFilter: false,
                lead_types: [
                    {id: 'LAT', name: 'Lead Ativo'},
                    {id: 'LNO', name: 'Lead Novo'},
                    {id: 'LSI', name: 'Lead S/ Interação'},
                    {id: 'LEA', name: 'Lead em Atraso'},
                    {id: 'LAG', name: 'Lead Agendado'},
                    {id: 'LPE', name: 'Lead Perdido'},
                    {id: 'LCO', name: 'Lead Convertido'}
                ],
                limit: 5,
                limits : [
                    { limit : 5, text : 'Exibir 5(cinco) por página' },
                    { limit : 10, text : 'Exibir 10(dez) por página' },
                    { limit : 25, text : 'Exibir 25(vinte e cinco) por página' },
                    { limit : 50, text : 'Exibir 50(cinquenta) por página' },
                ],
                listProposals: [],
                salesmans: [],
                total: 0,
                to : 0,
                passTo: null
            };
        },
        methods: {
            pageChange(_pageNum) {
                var self = this;
                self.currentPage = _pageNum;
                self.getData();
            },
            hideFilters() {
                var self = this;
                self.hideFilter = !self.hideFilter;
            },
            check(iterator) {
            },
            checkAll(items) {
                const self = this;
                for (let i of items) {
                    i.checked = !!(self.checked);
                }
                self.$forceUpdate();
            },
            async passLeads(items) {
                const self = this;
                const promises = [];
                if (!self.passTo) {
                    return false;
                }
                for (let i of items) {
                    if (i.checked) {
                        self.$root.$emit('onLoading');
                        i.user_id = self.passTo;

                        const response = self.$store.dispatch('lead/edit', i);
                        const a = new Promise(resolve => {
                            response.then(function () {
                                self.$root.$emit('onLoading');
                                resolve('ok');
                                self.$notify.success("Lead " + i.name + " atualizado com sucesso!");
                            });

                            response.catch(function (err) {
                                self.$root.$emit('onLoading');
                                resolve('err');
                                self.$notify.error("Erro ao atualizar lead " + i.name + "!");
                            });
                        });
                        promises.push(a);
                    }
                }
                Promise.all(promises).then(() => self.getData());
            },
            async getDataSalesmans() {
                var self = this;

                self.$root.$emit("onLoading");

                var params =
                        "branch_id=" +
                        JwtService.getBranchId() +
                        "&type_profile_id=" +
                        UserService.typeProfiles.salesman;

                const response = UserService.all(params);

                response.then(function (_users) {
                    self.salesmans = _users;
                    self.salesmans.push({id: '', name: 'Todos'});
                    self.salesmans.push({id: '-1', name: 'NÃO ATRIBUIDO'});
                    self.$root.$emit("onLoading");

                    self.getDataStatus();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");

                    self.getDataStatus();
                });
            },
            async getData() {
                var self = this;

                self.checked = false;
                self.$root.$emit('onLoading');

                if (self.form.interval) {
                    if (!Vue.moment(self.form.interval[0]).isValid()) {
                        delete self.form.interval;
                    } else {
                        if (!Vue.moment(self.form.interval[1]).isValid()) {
                            delete self.form.interval;
                        }
                    }
                }

                const response = self.$store.dispatch('lead/all', {
                    limit: self.limit,
                    currentPage: self.currentPage,
                    params: self.form
                });

                response.then(function (_pagination) {
                    self.leads = _pagination;
                    self.total = _pagination.total;
                    self.to = _pagination.to;
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getDataStatus() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('lead_status/all');

                response.then(function (x) {
                    self.$root.$emit('onLoading');
                    self.leads_status = x;
                    self.getData();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getData();
                });
            },
            onReset: function (_ev) {
                _ev.preventDefault();

                var self = this;

                self.form = {
                    interval: [Vue.moment(), Vue.moment().add(30, "days")],
                    leads_status_id: "",
                    lead_type: "",
                    user_id: ''
                };

                this.updateLeadType("active");

                self.currentPage = 1;

                self.getData();
            },
            onSubmit: function (_ev) {
                if(_ev !== undefined)
                    _ev.preventDefault();

                var self = this;

                self.setQueryString();

                self.currentPage = 1;

                self.getData();
            },
            remove: function (_item) {
                var self = this;

                self.$dialog
                        .confirm("Deseja realmente remover a proposta " + _item + "?")
                        .then(function () {
                            self.$root.$emit("onLoading");

                            const response = self.$store.dispatch("proposals/rem", {id: _item});

                            response.then(function () {
                                self.$root.$emit("onLoading");
                                self.$notify.success("Proposta excluída com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit("onLoading");
                                self.$notify.danger("Não foi possível excluir a proposta!");
                            });
                        });
            },
            updateLeadType: function(_leadType)
            {
                var self = this;
                self.form.lead_type = _leadType;
                self.form.leads_status_id = '';

                switch (_leadType) {
                    // Ativo
                    case 'active':
                    // Sem interação
                    case 'interaction':
                    // Em atraso
                    case 'late':
                        self.form.interval = [];
                        break;

                    default:
                        if (self.form.interval.length == 0) {
                            self.form.interval = [Vue.moment(), Vue.moment().add(30, "days")];
                        }
                }
            },
            initQueryString() {
                var self = this;
                var query = self.$route.query;

                self.limit = 5;

                if (query.limit) {
                    self.limit = parseInt(query.limit);
                }
                if (query.currentPage) {
                    setTimeout(function(){
                        self.pageChange(parseInt(query.currentPage));
                    }, 900);
                }
                if (query.interval && query.interval.length == 2) {
                    self.form.interval = [
                        Vue.moment(query.interval[0]),
                        Vue.moment(query.interval[1])
                    ];
                }
                if (query.leads_status_id) {
                    self.form.leads_status_id = parseInt(query.leads_status_id);
                }
                if (query.user_id) {
                    self.form.user_id = parseInt(query.user_id);
                }
                if (query.lead_type) {
                    self.form.lead_type = query.lead_type;
                }
                if (query.name) {
                    self.form.name = query.name;
                }
            },
            setQueryString() {
                var self = this;

                self.$router.push({
                    name: "leads.supervise.index",
                    query: {
                        limit: self.limit ? self.limit : 5,
                        currentPage: self.currentPage,
                        user_id: self.form.user_id,
                        leads_status_id: self.form.leads_status_id,
                        lead_type: self.form.lead_type,
                        name: self.form.name,
                        interval: [
                            Vue.moment(self.form.interval[0]).format('YYYY-MM-DD'),
                            Vue.moment(self.form.interval[1]).format('YYYY-MM-DD')
                        ]
                    }
                })
            }
        }
    }
</script>
